import { DraftEmailType } from '@this+that/models';

import { HandlerButton } from '../hooks';

const draftTypeByButton: Partial<Record<HandlerButton, DraftEmailType>> = {
  [HandlerButton.REPLY_ALL]: DraftEmailType.REPLY,
  [HandlerButton.REPLY]: DraftEmailType.REPLY,
  [HandlerButton.FORWARD]: DraftEmailType.FORWARD,
};

export const handleSelectDraftReqType = (
  button?: HandlerButton,
): DraftEmailType => {
  return draftTypeByButton[button!] ?? DraftEmailType.CREATE;
};
